import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from "./View/Home/home";
import { Products } from "./View/Products/products";
import './css/fonts.css';
import './css/global.css';
import PowerManagementList from "./View/header-menu/PowerManagement";
import AC from "./View/AC/ac";
import { BasicStation, PremiumStation, SmartStation, DualStation } from "./View/AC/stationPages";
import DC from "./View/DC/dc";
import ContactPage from "./View/header-menu/contact";
import EVChargingFAQ from "./View/header-menu/EVChargingFAQ";
import ChargingCalculator from "./View/header-menu/Calculate";
import Solutions from "./View/header-menu/WhereCanYouPlace";
import ScrollToTop from "./View/scrollToTop";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/ac" element={<AC />} />
                <Route path="/ac/basic" element={<BasicStation />} />
                <Route path="/ac/premium" element={<PremiumStation />} />
                <Route path="/ac/smart" element={<SmartStation />} />
                <Route path="/ac/dual" element={<DualStation />} />
                <Route path="/dc" element={<DC />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/calculate" element={<ChargingCalculator />} />
                <Route path="/products" element={<Products />} />
                <Route path="/powermanagement" element={<PowerManagementList />} />
                <Route path="/solitions" element={<Solutions />} />
                <Route path="/questions" element={<EVChargingFAQ />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;